import { render } from "./Spinner.vue?vue&type=template&id=a9adc7ec"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=a9adc7ec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__